import { getRTL } from "@fluentui/react";
export const confettiAnimationDuration = "0.6s";
/**
 * Source: https://codepen.io/thebabydino/details/RRRRZE
 * NOTE: This is externally-licensed OSS code. Do not copy/paste from this file.
 *
 * Base confetti mixin.
 * The size of each confetti is based on the parent element that the boxShadow is applied to.
 * @param k Interpolation value from 0 - 1.
 * @param bubbleRadius Radius of bubble in rem. This determines how far confettis travel from the center.
 * @param confettiDiameter Diameter of a confetti in rem. This is used to calculate how much to shrink the confetti. (Does not determine actual size of confetti)
 * @param numGroups Number of confettis to render. Size of consines, sines, and colors should equal numGroups.
 * @param cosines Array of x components for each confetti direction unit vector.
 * @param sines Array of y components for each confetti direction unit vector.
 * @param colors Array of colors for each confetti..
 */ export const confetti = (k, bubbleRadius, confettiDiameter, numGroups, cosines, sines, colors)=>{
    const shadowList = [];
    const groupDistrR = (1 + k * 0.25) * bubbleRadius * 1.3; // confetti distance from center increases as k approaches 1
    const confettiRadius = 0.5 * confettiDiameter;
    const spreadRadius = -1 * k * confettiRadius - 0.05; // spreadRadius (size of confetti) gets smaller as k approaches 1
    const rtlFactor = getRTL() ? -1 : 1;
    for(let i = 0; i < numGroups; i++){
        const xg = groupDistrR * cosines[i] * rtlFactor;
        const yg = groupDistrR * sines[i];
        const xs = xg + confettiDiameter * cosines[0];
        const ys = yg + confettiDiameter * sines[0];
        shadowList.push(`${xs}rem ${ys}rem 0 ${spreadRadius}rem ${colors[i]}`);
    }
    const boxShadowValue = shadowList.join(", ");
    return {
        boxShadow: boxShadowValue
    };
};
/**
 * Base bubble mixin
 * @param bubbleRadius Bubble radius in rem.
 */ export const bubble = (bubbleRadius)=>({
        transform: "scale(1)",
        borderWidth: `${bubbleRadius}rem`
    });
